export default __webpack_public_path__ + "static/spanishGoogleWalletGraphic-2830c36a958c3326fca5ca0f8f4940a6.svg";